import { LabelHTMLAttributes } from 'react'

type Custom = {
  required?: boolean
}

type LabelProps = Custom & LabelHTMLAttributes<HTMLLabelElement>

export default function Label(props: LabelProps) {
  const { children, required } = props

  return (
    <label className="font-base mb-1 block text-sm font-medium text-black-100" {...props}>
      {children} {required && <span className="text-red-60">*</span>}
    </label>
  )
}
